var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pgValidador"}},[_c('qrcode-vue',{attrs:{"value":_vm.identificador,"size":"500"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }